import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const initBackToTop = (lenis) => {
    const btn  = document.querySelector('.js-back-to-top');
    if (!btn) return;

    const line = btn.querySelector('span span'); // le <span> avec w-[1px]

    // Apparition au scroll
    ScrollTrigger.create({
        id: 'back-to-top',
        start: '200px top',
        onEnter:     () => gsap.to(btn, { opacity: 1, duration: 0.4, ease: 'power2.out' }),
        onLeaveBack: () => gsap.to(btn, { opacity: 0, duration: 0.4, ease: 'power2.in' }),
    });

    btn.addEventListener('click', () => {
        lenis.scrollTo(0, {
            duration: 1.2,
            ease: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        });
    });
};

export const hideBackToTop = () => {
    const btn = document.querySelector('.js-back-to-top');
    if (btn) gsap.set(btn, { opacity: 0 });
};